
<div>
  <template v-if="objectType === 'Form'">
    <search-forms
      v-if="searchType === 'analystDashboardForms'"
      v-model="selectedInstanceObject"
      @input="instanceObjectSelected"
      :organization-id="organization.id"
      :disabled="!isEditing"
      analyst-dashboard-endpoint
    />
  </template>

  <template v-if="objectType === 'Portal'">
    <a-select
      v-model="selectedInstanceObject"
      bind-by-object
      :options="portalSelectOptions"
      @input="instanceObjectSelected"
      :disabled="!isEditing"
    />
  </template>

  <template v-if="objectType === 'Folder'">

    <button v-if="isEditing" class="btn blue" @click="showHideModal('folderLookup', true)">
      {{ selectedInstanceObject ? selectedInstanceObject.name : 'Select Folder' }}
    </button>
    <button v-else>
      {{selectedInstanceObject.name}}
    </button>

    <div class="context-menu">
      <folder-move-to-contents
        v-if="modalState.folderLookup === true"
        :folder="folder"
        :options="folderLookupOptions"
        @close="showHideModal('folderLookup', false)"
        @selected="selectFolderFromLookup"
      ></folder-move-to-contents>
    </div>
  </template>
</div>
